import { post, API_URL } from '@/utils/request'
import { getRoles } from '@/utils/auth'

// 接口前缀
function apiFirstName() {
  return getRoles()[0] || 'taoke'
}

/**
 * 用户登录
 *
 * @param {String} telephone 手机号码（用户名）必填
 * @param {String} password 密码(不输入密码，就需要手机号验证码)
 * @param {String} captcha_r 验证码的请求码r(使用密码登录需要)
 * @param {String} captcha_code 用户读到的验证码(不区分大小写)
 * @param {String} telephone_code 手机号验证码
 */
export function login(data, isadmin=false) {
  // 管理员登录
  if (isadmin) {
    return post('admin_login', data)
  }
  return post('taoke_login', data)
}


/**
 * 用户登出
 */
export function logout() {
  return post(`${apiFirstName()}_logout`)
}


// 模拟获取用户信息接口
export function user_info() {
  return post(`${apiFirstName()}_myinfo`)
}

/**
 * 图形验证码
 * 
 * @param {String} r 长度15位及以上的随机字符串
 * @param {Number} t 时间戳，避免图片304
 */
export function captcha(r, t=Date.now()) {
  return API_URL + `?do=captcha&r=${r}&t=${t}`
}
